<template>
	<div class="register-second-step">
		<h3 class="login-form__title login-form__text-mobile">
			<span v-if="liveAccount" v-html="accountDinamic"></span>
			<span v-if="!liveAccount"> {{ $t('register.startDemo') }} </span>
		</h3>

		<p v-if="liveAccount" class="login-form__subtitle" v-html="$t('register.dinamicDescLive')" @click="changeAccount('live')"></p>
		<p v-if="!liveAccount" class="login-form__subtitle" v-html="$t('register.dinamicDescDemo')" @click="changeAccount('demo')"></p>

		<div class="social_buttons">
			<button @click="doFederatedLogIn('Google')" type="button">
				<img src="/assets/images/google.svg" alt="" class="google-icon" />
				<p class="showDesk">{{ $t('loginBox.logInGoogle') }}</p>
				<p class="showMobile">Google</p>
			</button>
			<button @click="doFederatedLogIn('Facebook')" type="button">
				<img src="/assets/images/facebook.svg" alt="" class="facebook-icon" />
				<p class="showDesk">{{ $t('loginBox.logInFacebook') }}</p>
				<p class="showMobile">Facebook</p>
			</button>
		</div>

		<div class="login-form__or">
			<div class="login-form__or__label">{{ $t('register.or') }}</div>
		</div>

		<div class="login-form__form">
			<div class="register-inputs-password">
				<TVInputBase
					v-model="emailModel"
					name="email"
					type="email"
					:label="$t('register.email')"
					:placeholder="$t('loginBox.placeholderEmail')"
					:error="emailError"
					:customErrorMessage="emailError ? emailError : ''"
					style="width: 100%"
				/>

				<TVInputPassword
					v-model="password1"
					name="labelled-field-password-1"
					:label="$t('register.secure')"
					:placeholder="$t('loginBox.placeholderPassword')"
					:errorText="password1Error"
					:invalid="password1Error"
					toggleMask
					required
					style="width: 100%"
				/>

				<TVInputPassword
					v-model="password2"
					name="labelled-field-password-2"
					:label="$t('register.confirmPassword')"
					:placeholder="$t('loginBox.placeholderPassword')"
					:errorText="password2Error"
					:invalid="password2Error"
					toggleMask
					required
					style="width: 100%"
				/>
			</div>
			<div class="disclaimer-second-step" v-if="liveAccount">
				<div class="disclaimer">
					<p>{{ $t('register.disclaimer') }}</p>
				</div>
				<TVCheckboxSingle
					id="check_agree"
					:label="$t('register.byTicking')"
					v-model="disclaimer"
					name="purposeAccount"
					style="color: #344555"
					@change="valid = false"
					class="justify-content-center"
				/>
				<div
					v-if="disclaimerError"
					class="labelled-field-error"
					style="margin-left: 40px; margin-top: -25px"
				>
					<img class="error-icon" src="/assets/images/icon-error.svg" alt="" />
					<p class="error-text">{{ disclaimerError }}</p>
				</div>
			</div>

			<div class="btn-second-start">
				<button
					class="red-button"
					id="btnSubConf"
					@click="getStartedClicked"
					:disabled="isButtonDisabled"
				>
					{{ $t('register.getstarted') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { ref, computed, getCurrentInstance, watch, onMounted } from 'vue'
import { Auth } from 'aws-amplify'
import TVInputBase from '../../../modules/ui/TVInputBase.vue'
import TVInputPassword from '../../../modules/ui/TVInputPassword.vue'
import TVCheckboxSingle from '../../../modules/ui/TVCheckboxSingle.vue'
import { i18n } from '@/plugins/i18n'

export default {
	// name: 'Email and Password',
	components: {
		TVInputBase,
		TVInputPassword,
		TVCheckboxSingle,
	},
	props: {
		title: String,
		liveAccount: Boolean,
		category: String,
		email: String,
	},
	// emits: ['started'],
	setup(props, { emit }) {
		const internalInstance = getCurrentInstance()
		const emitter = internalInstance.appContext.config.globalProperties.emitter
		let emailModel = ref(null)
		let emailError = ref(null)
		let password1 = ref(null)
		let password2 = ref(null)
		let password1Error = ref(null)
		let password2Error = ref(null)
		let disclaimer = ref(false)
		let disclaimerError = ref(null)
		let valid = ref(false)
		let userNameExists = ref(null)
		let isInitialLoad = ref(true)

		const accountDinamic = computed(() => {
			const mappings = {
				INDIVIDUAL: i18n.global.t('register.liveIndividual'),
				JOINT: i18n.global.t('register.jointIndividual'),
				CORPORATE: i18n.global.t('register.corporateIndividual'),
			}
			return mappings[props.category] || ''
		})

		const isButtonDisabled = computed(() => {
			const hasErrors =
				emailError.value?.length > 0 ||
				password1Error.value?.length > 0 ||
				password2Error.value?.length > 0

			const isAnyFieldEmpty =
				!emailModel.value || !password1.value || !password2.value

			const disclaimerCheck = props.liveAccount ? !disclaimer.value : false

			// Deshabilita el botón si hay errores, si algún campo está vacío, o si el disclaimer no está marcado
			return hasErrors || isAnyFieldEmpty || disclaimerCheck
		})

		onMounted(async () => {
			const result = await verify2()
			if (result) {
				emailModel.value = result.attributes.email
			}
			isInitialLoad.value = false
		})

		const verify2 = async () => {
			try {
				let useremail = await Auth.currentAuthenticatedUser()
				return useremail
			} catch (error) {
				console.log('Usuario no autenticado:', error)
				return null // Retorna null si no hay un usuario autenticado
			}
		}

		const doFederatedLogIn = (provider) => {
			emitter.emit('federatedSignIn', {
				provider: provider,
				code: null,
				token: null,
			})
		}

		// Expresión regular para validar el formato del correo electrónico
		const isValidEmail = (email) => {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			return emailRegex.test(email)
		}

		// Criterios de validación de la contraseña
		const isValidPassword = (password) => {
			const minLength = 8
			const hasUppercase = /[A-Z]/.test(password)
			const hasNumber = /\d/.test(password)
			const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)

			// Verificar si la contraseña cumple con todos los criterios
			return (
				password.length >= minLength &&
				hasUppercase &&
				hasNumber &&
				hasSpecialChar
			)
		}

		const getStartedClicked = async () => {
			try {
				await new Promise((resolve) => {
					emit('started', emailModel.value, password1.value, disclaimer.value)
					emitter.on('userNameExists', (message) => {
						userNameExists.value = message
						emailError.value = userNameExists.value
						isButtonDisabled.value = false
					})
					resolve()
				})
				isButtonDisabled.value = true
			} catch (error) {
				console.error("Error al emitir el evento 'started':", error)
			}
		}

		const changeAccount = (type) =>{
			if(type === 'live'){
				window.location.href = '/en/register/1/demo-account'
			}
			if(type === 'demo'){
				window.location.href = '/en/register/1/live-account'
			}
			
		}

		// Observador para emailModel
		watch(emailModel, (newValue) => {
			if (!isInitialLoad.value) {
				if (!newValue || newValue === '') {
					emailError.value = i18n.global.t('register.passwordRequired')
				} else if (!isValidEmail(newValue)) {
					emailError.value = i18n.global.t('register.invalidEmail')
				} else {
					emailError.value = false
				}
			}
		})

		// Observador para password1
		watch(password1, (newValue) => {
			if (!isInitialLoad.value) {
				if (!newValue || newValue === '') {
					password1Error.value = i18n.global.t('register.passwordRequired')
				} else if (!isValidPassword(newValue)) {
					password1Error.value = i18n.global.t('register.invalidPassword')
				} else {
					password1Error.value = false
				}
			}
		})

		// Observador para password1
		watch(password2, (newValue) => {
			if (!isInitialLoad.value) {
				if (!newValue || newValue === '') {
					password2Error.value = i18n.global.t(
						'register.confirmPasswordRequired',
					)
				} else if (password1.value !== password2.value) {
					password2Error.value = i18n.global.t('register.passwordsDoNotMatch')
				} else {
					password2Error.value = false
				}
			}
		})

		return {
			accountDinamic,
			doFederatedLogIn,
			emailModel,
			password1,
			password2,
			disclaimer,
			emailError,
			password1Error,
			password2Error,
			disclaimerError,
			//     verify2,
			isValidEmail,
			isValidPassword,
			valid,
			isInitialLoad,
			isButtonDisabled,
			getStartedClicked,
			userNameExists,
			changeAccount
		}
	},
}
</script>
